// Collection view toggle: switches product cards between product and lifestyle photos.
// The choice lives on <html data-collection-view> so re-rendered product grids (filters, sorting, paging) keep it,
// and is remembered per browser.

const STORAGE_KEY = 'collection-view';
const VIEWS = ['product', 'lifestyle'];

const readView = () => {
  try {
    const view = localStorage.getItem(STORAGE_KEY);
    return VIEWS.includes(view) ? view : 'product';
  } catch (error) {
    return 'product';
  }
};

const applyView = (view) => {
  document.documentElement.setAttribute('data-collection-view', view);
  document.querySelectorAll('collection-view-toggle').forEach((toggle) => toggle.sync());
};

class CollectionViewToggle extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this._onClick);
    this.sync();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this._onClick);
  }

  sync() {
    const view = document.documentElement.getAttribute('data-collection-view') || 'product';
    this.querySelectorAll('[data-view]').forEach((button) => {
      button.setAttribute('aria-pressed', button.dataset.view === view ? 'true' : 'false');
    });
  }

  _onClick = (event) => {
    const button = event.target.closest('[data-view]');

    if (!button || !VIEWS.includes(button.dataset.view)) {
      return;
    }

    try {
      localStorage.setItem(STORAGE_KEY, button.dataset.view);
    } catch (error) {
      // Storage unavailable (private mode, blocked): the view still applies for this page.
    }

    applyView(button.dataset.view);
  };
}

if (!window.customElements.get('collection-view-toggle')) {
  document.documentElement.setAttribute('data-collection-view', readView());
  window.customElements.define('collection-view-toggle', CollectionViewToggle);
}
